import * as React from "react";
import { cn } from "@/lib/utils";
import { fieldControlClass } from "@/components/ui/input";

export const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        fieldControlClass,
        "h-auto min-h-24 py-2.5",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";
